module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('aside', {
    staticClass: "epicfm"
  }, [_c('p', {
    staticClass: "dedh"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii"
    }
  }, [_vm._v("“My chutneys and kasaundies are, after all, connected to my nocturnal scribblings—by day amongst the pickle-vats, by night within these sheets, I spend my time at the great work of preserving. Memory, as well as fruit, is being saved from the corruption of the clocks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("—Salman Rushdie, "), _c('em', [_vm._v("Midnight’s Children")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "land40"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0vii-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6347256","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/pref00.vue
// module id = 63
// module chunks = 0